import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import clsx from 'clsx'

import { RoutingPaths } from 'app/routes/routes'

import { Button } from 'shared/ui/button'

import s from './styles.module.scss'

export const RoomButton = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const handleClick = () => {
    navigate(RoutingPaths.tours.clientData.path())
  }

  return (
    <div className={s.emptyWrapper}>
      <div className={s.container}>
        <Button
          className={clsx(s.button, 'semi-bold-17')}
          onClick={handleClick}
          borderRadius="md"
        >
          {t('tours_block.select_room')}
        </Button>
      </div>
    </div>
  )
}
